import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-431eef33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-block-label-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"0.8125rem"},
  class: "fas fa-eye"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"0.8125rem"},
  class: "fas fa-eye-slash"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-image" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconText = _resolveComponent("IconText")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["collection-block-label p-2", _ctx.forcePublic || _ctx.collection.public ? 'public' : 'private'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["collection-block-label-header mb-3", { 'has-text-centered': _ctx.centered }])
    }, _toDisplayString(_ctx.collection.title), 3),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.collection.public)
        ? (_openBlock(), _createBlock(_component_IconText, {
            key: 0,
            dark: true,
            class: _normalizeClass({ 'is-justify-content-center': _ctx.centered })
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            text: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("collection.public-collection")), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createBlock(_component_IconText, {
            key: 1,
            dark: _ctx.forcePublic ? true : false,
            class: _normalizeClass({ 'is-justify-content-center': _ctx.centered })
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            text: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("collection.private-collection")), 1)
            ]),
            _: 1
          }, 8, ["dark", "class"])),
      _createVNode(_component_IconText, {
        class: _normalizeClass(["ml-1", { 'is-justify-content-center': _ctx.centered }]),
        dark: _ctx.forcePublic || _ctx.collection.public
      }, {
        icon: _withCtx(() => [
          _hoisted_4
        ]),
        text: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("collection.artworks", { amount: _ctx.collection.artworks.length || 0 })), 1)
        ]),
        _: 1
      }, 8, ["dark", "class"])
    ])
  ], 2))
}